<template>
  <div>
    <v-card-title>
      <h2>Message Search</h2>
    </v-card-title>
    <br />
    <v-layout
      row wrap
    >
      <v-flex
        sm12
      >
        <v-card
          style="margin-bottom: 10px;"
        >
          <v-card-text>
            <v-layout
              row
              wrap
            >
              <v-flex
                sm12
                md12
                style="padding:0 5px 0 5px;"
              >
                <v-text-field
                  v-model="searchText"
                  append-icon="search"
                  label="Search Text"
                  single-line
                  hide-details
                  @blur="search"
                  v-on:keyup.enter="search"
                >
                  <template v-slot:append>
                    <v-icon
                      v-if="searchText != ''"
                      size="24"
                      @click="searchText = ''; search()"
                    >
                      mdi-close
                    </v-icon>
                    <v-fade-transition
                      leave-absolute
                    >
                      <v-progress-circular
                        v-if="loading"
                        size="24"
                        color="info"
                        indeterminate
                      ></v-progress-circular>
                    </v-fade-transition>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex
                sm12
                md6
              >
                <v-menu
                  v-model="dateModal1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template slot="activator">
                    <v-text-field
                      v-model="dateFrom"
                      label="Search From"
                      prepend-inner-icon="event"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dateFrom" @input="dateModal1 = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex
                sm12
                md6
              >
                <v-menu
                  v-model="dateModal2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template slot="activator">
                    <v-text-field
                      v-model="dateTo"
                      label="Search To"
                      prepend-inner-icon="event"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dateTo" @input="dateModal2 = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex
                sm6
              >
                <v-combobox
                  v-model.trim="filterTags"
                  :items="tagResults"
                  :search-input.sync="tagSearch"
                  label="Search by Tag"
                  item-text="tag"
                  item-value="tag"
                  :return-object="false"
                  flat
                  small-chips
                  hide-selected
                  auto-select-first
                  @input="tagSearch = ''"
                />
              </v-flex>
              <v-spacer/>
              <v-flex
                sm6
                md3
              >
                <v-radio-group
                  v-model="readFilter"
                  row
                >
                  <v-radio
                    label="All"
                    :value="null"
                  ></v-radio>
                  <v-radio
                    label="Read"
                    :value="true"
                  ></v-radio>
                  <v-radio
                    label="Unread"
                    :value="false"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="clearSearch"
              flat
            >
              <v-icon
                left
              >
                close
              </v-icon>
              Clear
            </v-btn>
            <v-btn
              @click="search"
              color="primary"
            >
              <v-icon
                left
              >
                search
              </v-icon>
              Search
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex
        sm12
      >
        <v-card>
          <v-data-table
            :items="messages"
            :headers="headers"
            :pagination.sync="pagination"
            :total-items="totalMessages"
            :rows-per-page-items="paginationStrings"
            :loading="loading"
            disable-initial-sort
          >
            <template slot="no-data">
              <tr>
                <td colspan="4">
                  <div style="text-align:center;padding:25px;">
                    <v-icon size="125px">find_in_page</v-icon>
                    <h3>No Results</h3>
                  </div>
                </td>
              </tr>
            </template>
            <template
              slot="items"
              slot-scope="props"
            >
              <tr
                :style="(props.item.read || props.item.type == 'to client') ? '' : 'background: #ffffa8;'"
              >
                <td>
                  <v-icon>
                    {{props.item.type == "to client" ? 'mdi-inbox-arrow-up' : 'mdi-inbox-arrow-down'}}
                  </v-icon>
                </td>
                <td>
                  <div
                    style="padding: 5px;"
                  >
                    <div
                      style="font-weight: bold;"
                    >
                      {{props.item.subject}}
                    </div>
                    <div
                      style="padding: 10px;max-height: 200px;overflow-y:auto;"
                      v-html="props.item.message"
                    />
                    
                    <small style="padding-left: 10px;">
                      Sent at: {{convertToLocal(props.item.sent_at)}}
                    </small>
                  </div>
                </td>
                <td colspan="1">
                  <div
                    v-if="props.item.contact_id" 
                  >
                    <ContactPreview
                      :id="props.item.contact_id"
                      :key="props.item.contact_id"
                    />
                    <small>
                      <span
                        v-for="tag in props.item.contact_tags"
                        :key="tag.name"
                      >
                        <v-chip
                          label
                          small
                          style="padding: 2px 5px;max-width: 260px; overflow: hidden !important; text-overflow: ellipsis; margin-top: 5px; margin-left: 0; margin-right: 10px;"
                        >
                          {{tag.name}}
                        </v-chip>
                      </span>
                    </small>
                  </div>
                  <div v-else>
                    <b>{{ props.item.sent_to_name }}</b>
                  </div>
                </td>
                <td>
                  <div
                    v-if="props.item.type == 'from client' && checkPermission('contacts_messages_read', PERMISSIONS.CAN_EDIT)"
                  >
                    <v-icon
                      v-if="!props.item.read"
                      @click="read(props.item)"
                    >
                      mdi-eye
                    </v-icon>
                    <v-icon
                      v-else
                      style="opacity: 0.6;"
                      @click="read(props.item, false)"
                    >
                      mdi-eye-off-outline
                    </v-icon>
                  </div>
                </td>
              </tr>
            </template>
            <template slot="actions-append">
              <v-tooltip left>
                <span slot="activator">
                  <v-btn
                    round
                    flat
                    fab
                    small
                    @click="downloadCSV()"
                  >
                    <v-icon
                      color="green"
                    >
                      table_chart
                    </v-icon>
                  </v-btn>
                </span>
                <span>Download CSV<br /><small>Of Current Search Terms</small></span>
              </v-tooltip>
              <v-spacer />
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="downloadingCSV"
      persistent
      width="300"
    >
      <v-card
        color="white"
      >
        <v-card-text>
          Generating CSV File...<br/>
          <small>Depending on your query, this may take some time.</small>
          <v-progress-linear
            indeterminate
            color="blue"
            class="mb-0"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import pagination from '@/components/global/pagination'
import ContactPreview from '../contacts/ContactPreview.vue'

export default {
  name: 'ContactMessageSearch',
  mixins: [
    pagination
  ],
  components: {
    ContactPreview
  },
  data () {
    return {
      messages: [],
      pagination: {},
      searchText: '',
      dateFrom: '',
      dateTo: '',
      loading: true,
      paginationStrings: [
        10, 25, 50
      ],
      headers: [
        { text: '', value: '', sortable: false, width: 50 },
        { text: 'Message', sortable: false, width: 650 },
        { text: 'Contact', sortable: false },
        { text: 'Read', value: 'read', width: 75 }
      ],
      readFilter: null,
      dateModal1: false,
      dateModal2: false,
      readFilter: null,
      filter: {},
      downloadingCSV: false,
      tagSearch: null, 
      tagResults: [],
      filterTags: null
    }
  },
  created () {
    this.documentTitle('Message Search')
  },
  computed: {
    totalMessages () {
      return this.pagination.totalItems
    }
  },
  watch: {
    tagSearch () {
      if(this.tagSearch){
        this.fetchTags()
      }     
    }
  },
  methods: {
    fetch () {
      this.loading = true
      if (!this.componentCreated) {
        if (!this.$route.query.order) {
          this.pagination.sortBy = 'sent_at'
          this.pagination.descending = true
        }
      }
      api.bulkmail.mailsearch.list({
        search: this.searchText, ordering: (this.pagination.descending ? '-' : '') + this.pagination.sortBy, pageNum: this.pagination.page, count: this.pagination.rowsPerPage,
        filter: this.filter
      })
        .then(data => {
          this.messages = data.results
          this.pagination.page = data.page_number
          this.pagination.totalItems = data.count
          this.loading = false
          this.componentCreated = true
        })
    },
    downloadCSV () {
      this.downloadingCSV = true
      api.bulkmail.mailsearch.downloadCsv({search: this.searchText, ordering: (this.pagination.descending ? '-' : '') + this.pagination.sortBy, filter: this.filter || null})
        .then(response => {
          this.downloadingCSV = false
          let blob = new Blob([response.data])
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'Export_ContactMessageSearch.csv'
          link.click()
        })
    },
    search () {
      this.pagination.page = 1
      var queryParam = {}, filterQueryParam = {}
      if (this.searchText) {queryParam['search'] = this.searchText}

      if (this.dateFrom) {filterQueryParam['sent_at__gte'] = new Date(this.dateFrom).toISOString()} else {delete filterQueryParam['sent_at__gte']}
      if (this.dateTo) {filterQueryParam['sent_at__lte'] = new Date(this.dateTo).toISOString()} else {delete filterQueryParam['sent_at__lte']}
      if (this.readFilter !== null) {
          filterQueryParam['read'] = this.readFilter
          filterQueryParam['type'] = 'from client'
        } else {
          delete filterQueryParam['read']
          delete filterQueryParam['type']
      }
      if (this.filterTags) {filterQueryParam['tags__name'] = this.filterTags} else {delete filterQueryParam['tags__name']}
      if (Object.keys(filterQueryParam).length !== 0) {queryParam['filter'] = JSON.stringify(filterQueryParam)}
      this.$router.push({ query: queryParam })
    },
    read (item, read = true) {
      api.bulkmail.mailsearch.read(item, read)
      .then(() => {
        item.read = read
      })
    },
    clearSearch () {
      this.dateFrom = null
      this.dateTo = null
      this.readFilter = null
      this.searchText = null
      this.filterTags = null
      this.search()
    },
    fetchTags () {
      api.userform.contactTags.get(this.tagSearch)
        .then(tagResults => {
          this.tagResults = tagResults
        })
    }
  }
}
</script>

<style>

.search-bar {
  margin-top: 1em;
}

table {
  margin-top: 1em;
}

.v-chip__content {
      display: block !important;
      padding: 5px 12px !important;
      overflow: hidden;
      text-overflow: ellipsis;
}
</style>
